import axios, { AxiosResponse } from 'axios';
import { AppError } from '@/errors/appError';
import { changePassword, changeSettings, changeTimeZone, checkDocuments } from '@/api/user';
import { IToolUserSettings } from '@/types';

export const userService = {
    async changePassword(params: Record<string, string>): Promise<AxiosResponse | void> {
        try {
            return await changePassword(params);
        } catch (e) {
            throw new AppError(`Unable to change password, request error`, { cause: e });
        }
    },

    async changeTimeZone(timeZoneCode: string) {
        try {
            return await changeTimeZone(timeZoneCode);
        } catch (e) {
            throw new AppError(`Unable to change timeZone, request error`, { cause: e });
        }
    },

    async changeSettings(settings: IToolUserSettings) {
        try {
            return await changeSettings(settings);
        } catch (e) {
            throw new AppError(`Unable to change user settings, request error`, { cause: e });
        }
    },

    async checkDocuments() {
        try {
            return await checkDocuments();
        } catch (e) {
            throw new AppError(`Unable to chack documents, request error`, { cause: e });
        }
    },

    async uploadDocuments(params: FormData) {
        return await axios.post('/api/toolUser/uploadDocuments', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    },
};
